import { ModuleTypeEnum } from '#pagebuilder/lib/enums/ModuleTypeEnum.js';

export function getPersistSyncKey(activeRoute){
    if(!activeRoute){
        return null;
    }

    return activeRoute.moduleType === ModuleTypeEnum.CONTEXT ? activeRoute.pageId : activeRoute.pageType;
}

export function getPersistWidgetSelectionSyncKey(activeRoute){
    if(!activeRoute){
        return null;
    }

    const syncKey = getPersistSyncKey(activeRoute);

    return activeRoute.moduleType === ModuleTypeEnum.CONTEXT ? ModuleTypeEnum.CONTEXT+'.'+syncKey : syncKey;
}
